import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

export async function getMachinesCountByMonthApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/machines-count-by-month`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}

export async function getMachinesCountAndInvestmentsByHazardApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/machines-count-and-investments-by-hazard`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}

export async function getTotalInvestedByMonthApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/total-invested-by-month`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}

export async function getTotalToInvestByMonthApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/total-to-invest-by-month`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}

export async function getTotalToInvestPercentageByMonthApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/total-to-invest-percentage-by-month`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}

export async function getInvestedPercentileByHazardApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/invested-percentile-by-hazard`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}

export async function getRisksPercentageByHazardApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/risks-percentage-by-hazard`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}
/**
 * @param {Object} params
 * @param {number} params.unitId
 * @param {number} params.corporateGroupId
 * @param {string} params.sector
 * @param {string} params.businessType
 * @param {number} params.machineId
 */
export function getActionPlansByLast12MonthsApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  return axios.get(
    `${API_URL}/api/admin/company-report/action-plans-by-last-12-months`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
}
export async function getHazardsByLast12MonthsApi({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  const response = await axios.get(
    `${API_URL}/api/admin/company-report/hazards-by-last-12-months`,
    {
      params: {
        "corporate-group-id": corporateGroupId,
        sector,
        "business-type": businessType,
        "machine-id": machineId,
        "company-id": unitId,
      },
    }
  );
  return response.data;
}
